let html = `<div class="about">
    <div>#{install_extension_rule_2}</div>

    <p>#{install_extension_rule_3}</p>

    <p>#{install_extension_rule_4}</p>

    <p>#{install_extension_rule_5}</p>

    <p style="margin-bottom: 0">#{install_extension_rule_7}</p>
</div>`

export default html